<template>

  <section class="px-14 sm-max:px-5 mt-20 md-max:mt-10" id="testimonial">

    <div class="relative">
      <nuxt-img
          :src="imageSrc"
          :alt="imageAlt"
          class="mx-auto opacity-1"
          width="1040"
          height="585"
          format="webp"
          sizes="sm:400px md:100vw lg:100vw xl:1024px"
          loading="lazy"
          :class="showVideo ? 'opacity-0 duration-150 absolute top-0 left-0 right-0 bottom-0 m-auto left-6/12 m-0' : ''"
      ></nuxt-img>
      <button
          id="play-button-hero" @click="playVid()" v-if="!showVideo" aria-label="Start video"
          class="absolute inset-0 flex flex-col justify-center w-full h-full text-base text-white bg-opacity-75"
      >
        <svg
            class="w-32 m-auto sm-max:w-12"
            viewBox="-13 -7 205 151"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_13_831)">
            <rect x="31" y="8" width="120" height="120" rx="60" fill="#FAF7F5"/>
            <path
                d="M106.466 65.4079C108.376 66.6081 108.376 69.3919 106.466 70.5921L84.0571 84.6715C82.0185 85.9524 79.3673 84.4871 79.3673 82.0795L79.3673 53.9205C79.3673 51.5129 82.0185 50.0476 84.0571 51.3284L106.466 65.4079Z"
                fill="#f87832"/>
          </g>
          <defs>
            <filter id="filter0_d_13_831" x="0.387754" y="0.653061" width="181.224" height="181.224"
                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                             result="hardAlpha"/>
              <feOffset dy="23.2653"/>
              <feGaussianBlur stdDeviation="15.3061"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0.211765 0 0 0 0 0.2 0 0 0 0 0.14902 0 0 0 0.3 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13_831"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13_831" result="shape"/>
            </filter>
          </defs>
        </svg>

      </button>

      <div class="max-w-screen-lg m-auto">
        <div id="video-container" class="relative overflow-hidden h-[0px] pb-[56.25%]" v-if="showVideo">
          <iframe
              v-if="videoPLay"
              id="myVideo"
              :src="videoIframeSrc"
              class="absolute left-0 top-0 w-full h-full rounded-3xl"
              allow="autoplay; fullscreen"
              allowfullscreen>
          </iframe>
        </div>
      </div>

    </div>

    <div class="lg:text-lg text-15 text-center pt-2 md-max:px-4" v-html="text1">

    </div>

    <div class="text-center md-max:pt-8 pt-12 lg:text-21 md:lg text-15 md-max:px-4" v-html="text2">
    </div>

    <h2 class="lg:text-38 md:text-28 md-max:mt-0 text-2xl mt-4 text-center md-max:pt-4 pb-16 mb-4 border-b border-[#f0f0f0] sm-max:pb-6">
      <strong v-html="text3"></strong></h2>

    <div class="grid grid-cols-2 md-max:grid-cols-1 gap-8 pt-4 last-border">
      <div class="col-span-1 sm-max:col-span-1 pb-2"
           :class="{ 'border-b border-borderGray': index !== reviews.length - 2  && index !== reviews.length - 1}" v-for="(review, index) in reviews"
           :key="index">
        <div class="grid grid-cols-12 gap-6 lg:mb-10">
          <div class="col-span-3 sm-max:col-span-12 sm-max:text-center">
            <nuxt-img
                :src="review.productImage"
                alt="product-1"
                class="border-2 border-[#e8e8e8] w-full sm-max:max-w-xs md-max:m-auto"
                :class="index === 0 ? 'sm-max:w-full' : 'md-max:w-32'"
                width="112"
                height="84"
                format="webp"
                loading="lazy"
                style="box-shadow: 0px 0px 4px #CCB;"
            ></nuxt-img>
          </div>

          <div class="col-span-9 space-y-2 sm-max:col-span-12 sm-max:text-center">
            <nuxt-img
                :src="review.ratingImage"
                alt="rating"
                class="sm-max:m-auto"
                width="100"
                height="16"
                format="webp"
                loading="lazy"
            ></nuxt-img>

            <div
                class="review-item-title xs-max:text-left font-open-sans text-productTitle text-15 sm-max:text-base pt-1" v-html="review.title">

            </div>

            <div class="text-13 md:leading-5 xs-max:text-left font-open-sans review-item-message" v-html="review.message">

            </div>

            <div class="text-15 text-[#808080]  font-open-sans flex xs-max:!justify-left xs-only:justify-center pb-4">
          <span class="pr-2 font-open-sans text-15 " v-html="review.reviewerName">

          </span>

              <nuxt-img
                  :src="review.verifiedIcon"
                  alt="rating"
                  class="h-4 relative top-1"
                  width="12"
                  height="15"
                  format="webp"
                  loading="lazy"
              ></nuxt-img>

              <span class="text-[#1cc286] pl-2 text-xs relative top-1 font-open-sans" v-html="textVerified">

          </span>

            </div>

            <div class="text-[11px] italic text-[#777] !mt-0 font-open-sans xs-max:text-left" v-html="review.productDetails">

            </div>

          </div>
        </div>
      </div>

      <div class="col-span-1 sm-max:col-span-1 lg:-mt-10">

        <nuxt-img
            :src="organicCoffeeSrc"
            :alt="organicCoffeeAlt"
            class="lg:w-full m-auto lg:px-12 md-max:w-full py-0 md-max:py-0 sm-max:mb-10"
            format="webp"
            loading="lazy"
        ></nuxt-img>

      </div>


    </div>

  </section>

</template>

<script setup>

import {ref} from 'vue';

const showVideo = ref(false);
const videoPLay = ref(false);

const playVid = () => {
  videoPLay.value = true;
  showVideo.value = true;
};

defineProps({
  imageSrc: {
    type: String,
    default: '/assets/images/video-bg.png'
  },
  imageAlt: {
    type: String,
    default: 'image video'
  },
  videoIframeSrc: {
    type: String,
    default: 'https://player.vimeo.com/video/439100268?autoplay=1#t=0s'
  },
  text1: {
    type: String,
    default: 'Real people experiencing Lifeboost Coffee for the first time (watch above)'
  },
  text2: {
    type: String,
    default: 'I love this coffee so much, I’ve had to share it with everyone I know.'
  },
  text3: {
    type: String,
    default: 'What People Have To Say'
  },
  textVerified: {
    type: String,
    default: 'Verified Buyer'
  },
  reviews: {
    type: Array,
    default: () => [
      {
        productImage: '/assets/images/product-1.png',
        ratingImage: '/assets/images/rating-yellow.png',
        title: 'Great Coffee',
        message: 'This coffee is very expensive, and worth every dime. I can drink without adding anything, no sugar or cream. So mellow and tasty! Thank you',
        reviewerName: 'Bonnie B',
        verifiedIcon: '/assets/images/verified-icon.jpg',
        productDetails: 'Single Origin Medium Roast Coffee 12 oz Bag - Bundle'
      },
      {
        productImage: '/assets/images/product-2.jpg',
        ratingImage: '/assets/images/rating-yellow.png',
        title: 'Good coffee',
        message: 'Great coffee !!!!',
        reviewerName: 'Anita E. ',
        verifiedIcon: '/assets/images/verified-icon.jpg',
        productDetails: 'Single Origin Medium Roast Coffee 12 oz Bag - 50% Off Special'
      },
      {
        productImage: '/assets/images/product-3.jpg',
        ratingImage: '/assets/images/rating-yellow.png',
        title: 'Delicious',
        message: 'Best coffee out there! Great taste!',
        reviewerName: 'Edward T.',
        verifiedIcon: '/assets/images/verified-icon.jpg',
        productDetails: 'Single Origin Espresso Coffee 12 oz Bag'
      },
      {
        productImage: '/assets/images/product-4.jpg',
        ratingImage: '/assets/images/rating-yellow.png',
        title: 'Taste & smells just like Grandpa\'s coffee!',
        message: 'Love the product and you certainly can taste the difference.',
        reviewerName: 'Gay M. ',
        verifiedIcon: '/assets/images/verified-icon.jpg',
        productDetails: '6x Single Origin Medium Roast Coffee 12 oz Bag'
      },
      {
        productImage: '/assets/images/product-3.jpg',
        ratingImage: '/assets/images/rating-yellow.png',
        title: 'Excellent tasting!!',
        message: 'This coffee is great tasting!! Best so far!! ',
        reviewerName: 'Edward T. ',
        verifiedIcon: '/assets/images/verified-icon.jpg',
        productDetails: 'Single Origin Espresso Coffee 12 oz Bag'
      },
      {
        productImage: '/assets/images/product-2.jpg',
        ratingImage: '/assets/images/rating-yellow.png',
        title: 'Best coffee ever',
        message: 'This coffee is everything they say it is. So smooth no acid at all. So glad I found it.',
        reviewerName: 'Lisa R. ',
        verifiedIcon: '/assets/images/verified-icon.jpg',
        productDetails: '1x Single Origin Medium Roast Coffee 12 oz Bag'
      },
      {
        productImage: '/assets/images/product-2.jpg',
        ratingImage: '/assets/images/rating-yellow.png',
        title: 'Great coffee, fast delivery!',
        message: 'Lifeboost shipped my order so fast that it felt like my first cup came right off the tree! This was the most vibrant experience of coffee I\'ve ever had, and I highly recommend Lifeboost to anyone who wants to experience coffee as fresh and wonderful as it gets!',
        reviewerName: 'Karen M.  ',
        verifiedIcon: '/assets/images/verified-icon.jpg',
        productDetails: '3x Single Origin Medium Roast Coffee 12 oz Bag'
      },
      {
        productImage: '/assets/images/product-5.jpg',
        ratingImage: '/assets/images/rating-yellow.png',
        title: 'Life Boost Coffee',
        message: 'Life Boost Coffee is more than just drinking coffee - it’s an experience that no one should miss. It’s smooth with no bitter aftertaste and it’s delightfully pleasant. I’m glad Life Boost Coffee found me.',
        reviewerName: 'Everet K.',
        verifiedIcon: '/assets/images/verified-icon.jpg',
        productDetails: '3x Single Origin Medium Roast Coffee 12 oz Bag - One Bag Free'
      },
      {
        productImage: '/assets/images/product-3.jpg',
        ratingImage: '/assets/images/rating-yellow.png',
        title: 'My husband love it and',
        message: 'My husband love it and I start drinking coffee too. Knowing it’s kosher and stomach friendly, that’s why I’m confident to drink it.',
        reviewerName: 'Thelma K. ',
        verifiedIcon: '/assets/images/verified-icon.jpg',
        productDetails: 'Single Origin Medium Roast Coffee 12 oz Bag - 1st bag free'
      },
      {
        productImage: '/assets/images/product-3.jpg',
        ratingImage: '/assets/images/rating-yellow.png',
        title: 'Fabulous Coffee',
        message: 'We love Lifeboost coffee! been buying it for almost two years, with no plan to stop! Great taste, great value! Arrives right on time in super condition.',
        reviewerName: 'Deborah E.',
        verifiedIcon: '/assets/images/verified-icon.jpg',
        productDetails: 'Single Origin Dark Roast Coffee 12 oz Bag'
      },
      {
        productImage: '/assets/images/product-6.jpg',
        ratingImage: '/assets/images/rating-yellow.png',
        title: 'Best coffee I’ve ever had!!!',
        message: 'This coffee is so good and so much flavor. The decaf process was so clean with no chemicals and still retains the flavor. I served it to guests from Hawaii and he just texted me on how wonderful the coffee was I and I didn’t tell him it was decaf.',
        reviewerName: 'Kathleen M. ',
        verifiedIcon: '/assets/images/verified-icon.jpg',
        productDetails: '6x Decaf Coffee 12 oz Bag, Single Origin, Fair Trade Medium Roast\n'
      },
    ]
  },
  organicCoffeeSrc: {
    type: String,
    default: '/assets/images/product-organic.png'
  },
  organicCoffeeAlt: {
    type: String,
    default: 'product-organic'
  },
  buttonText: {
    type: String,
    default: 'Save 50% Now'
  },

})

defineBuilderComponent({
    friendlyName: "PeopleHaveToSay",
    canHaveChildren: true,
    inputs: [
        {
            name: "imageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "/assets/images/video-bg.png"
        },
        {
            name: "imageAlt",
            type: "text",
            defaultValue: "image video"
        },
        {
            name: "videoIframeSrc",
            type: "text",
            defaultValue: "https://player.vimeo.com/video/439100268?autoplay=1#t=0s"
        },
        {
            name: "text1",
            type: "richText",
            defaultValue: "Real people experiencing Lifeboost Coffee for the first time (watch above)"
        },
        {
            name: "text2",
            type: "richText",
            defaultValue: "I love this coffee so much, I’ve had to share it with everyone I know."
        },
        {
            name: "text3",
            type: "richText",
            defaultValue: "What People Have To Say"
        },
        {
            name: "textVerified",
            type: "richText",
            defaultValue: "Verified Buyer"
        },
        {
            name: "reviews",
            type: "list",
            subFields: [
                {
                    name: "productImage",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png",
                        "svg"
                    ]
                },
                {
                    name: "ratingImage",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png",
                        "svg"
                    ]
                },
                {
                    name: "title",
                    type: "richText"
                },
                {
                    name: "message",
                    type: "richText"
                },
                {
                    name: "reviewerName",
                    type: "richText"
                },
                {
                    name: "verifiedIcon",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png",
                        "svg"
                    ]
                },
                {
                    name: "productDetails",
                    type: "richText"
                }
            ],
            defaultValue: [
                {
                    productImage: "/assets/images/product-1.png",
                    ratingImage: "/assets/images/rating-yellow.png",
                    title: "Great Coffee",
                    message: "This coffee is very expensive, and worth every dime. I can drink without adding anything, no sugar or cream. So mellow and tasty! Thank you",
                    reviewerName: "Bonnie B",
                    verifiedIcon: "/assets/images/verified-icon.jpg",
                    productDetails: "Single Origin Medium Roast Coffee 12 oz Bag - Bundle"
                },
                {
                    productImage: "/assets/images/product-2.jpg",
                    ratingImage: "/assets/images/rating-yellow.png",
                    title: "Good coffee",
                    message: "Great coffee !!!!",
                    reviewerName: "Anita E. ",
                    verifiedIcon: "/assets/images/verified-icon.jpg",
                    productDetails: "Single Origin Medium Roast Coffee 12 oz Bag - 50% Off Special"
                },
                {
                    productImage: "/assets/images/product-3.jpg",
                    ratingImage: "/assets/images/rating-yellow.png",
                    title: "Delicious",
                    message: "Best coffee out there! Great taste!",
                    reviewerName: "Edward T.",
                    verifiedIcon: "/assets/images/verified-icon.jpg",
                    productDetails: "Single Origin Espresso Coffee 12 oz Bag"
                },
                {
                    productImage: "/assets/images/product-4.jpg",
                    ratingImage: "/assets/images/rating-yellow.png",
                    title: "Taste & smells just like Grandpa's coffee!",
                    message: "Love the product and you certainly can taste the difference.",
                    reviewerName: "Gay M. ",
                    verifiedIcon: "/assets/images/verified-icon.jpg",
                    productDetails: "6x Single Origin Medium Roast Coffee 12 oz Bag"
                },
                {
                    productImage: "/assets/images/product-3.jpg",
                    ratingImage: "/assets/images/rating-yellow.png",
                    title: "Excellent tasting!!",
                    message: "This coffee is great tasting!! Best so far!! ",
                    reviewerName: "Edward T. ",
                    verifiedIcon: "/assets/images/verified-icon.jpg",
                    productDetails: "Single Origin Espresso Coffee 12 oz Bag"
                },
                {
                    productImage: "/assets/images/product-2.jpg",
                    ratingImage: "/assets/images/rating-yellow.png",
                    title: "Best coffee ever",
                    message: "This coffee is everything they say it is. So smooth no acid at all. So glad I found it.",
                    reviewerName: "Lisa R. ",
                    verifiedIcon: "/assets/images/verified-icon.jpg",
                    productDetails: "1x Single Origin Medium Roast Coffee 12 oz Bag"
                },
                {
                    productImage: "/assets/images/product-2.jpg",
                    ratingImage: "/assets/images/rating-yellow.png",
                    title: "Great coffee, fast delivery!",
                    message: "Lifeboost shipped my order so fast that it felt like my first cup came right off the tree! This was the most vibrant experience of coffee I've ever had, and I highly recommend Lifeboost to anyone who wants to experience coffee as fresh and wonderful as it gets!",
                    reviewerName: "Karen M.  ",
                    verifiedIcon: "/assets/images/verified-icon.jpg",
                    productDetails: "3x Single Origin Medium Roast Coffee 12 oz Bag"
                },
                {
                    productImage: "/assets/images/product-5.jpg",
                    ratingImage: "/assets/images/rating-yellow.png",
                    title: "Life Boost Coffee",
                    message: "Life Boost Coffee is more than just drinking coffee - it’s an experience that no one should miss. It’s smooth with no bitter aftertaste and it’s delightfully pleasant. I’m glad Life Boost Coffee found me.",
                    reviewerName: "Everet K.",
                    verifiedIcon: "/assets/images/verified-icon.jpg",
                    productDetails: "3x Single Origin Medium Roast Coffee 12 oz Bag - One Bag Free"
                },
                {
                    productImage: "/assets/images/product-3.jpg",
                    ratingImage: "/assets/images/rating-yellow.png",
                    title: "My husband love it and",
                    message: "My husband love it and I start drinking coffee too. Knowing it’s kosher and stomach friendly, that’s why I’m confident to drink it.",
                    reviewerName: "Thelma K. ",
                    verifiedIcon: "/assets/images/verified-icon.jpg",
                    productDetails: "Single Origin Medium Roast Coffee 12 oz Bag - 1st bag free"
                },
                {
                    productImage: "/assets/images/product-3.jpg",
                    ratingImage: "/assets/images/rating-yellow.png",
                    title: "Fabulous Coffee",
                    message: "We love Lifeboost coffee! been buying it for almost two years, with no plan to stop! Great taste, great value! Arrives right on time in super condition.",
                    reviewerName: "Deborah E.",
                    verifiedIcon: "/assets/images/verified-icon.jpg",
                    productDetails: "Single Origin Dark Roast Coffee 12 oz Bag"
                },
                {
                    productImage: "/assets/images/product-6.jpg",
                    ratingImage: "/assets/images/rating-yellow.png",
                    title: "Best coffee I’ve ever had!!!",
                    message: "This coffee is so good and so much flavor. The decaf process was so clean with no chemicals and still retains the flavor. I served it to guests from Hawaii and he just texted me on how wonderful the coffee was I and I didn’t tell him it was decaf.",
                    reviewerName: "Kathleen M. ",
                    verifiedIcon: "/assets/images/verified-icon.jpg",
                    productDetails: "6x Decaf Coffee 12 oz Bag, Single Origin, Fair Trade Medium Roast\n"
                }
            ]
        },
        {
            name: "organicCoffeeSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "/assets/images/product-organic.png"
        },
        {
            name: "organicCoffeeAlt",
            type: "text",
            defaultValue: "product-organic"
        }
    ]
});
</script>

<style>
.review-item-message:after, .review-item-message:before {
  font-family: cursive;
  font-size: 20px;
  line-height: 10px;
}

.review-item-message:before {
  content: '" ';
}

.review-item-message:after {
  content: ' \201D';
}

</style>